interface RegistryFactoryClosure<FactoryIn,FactoryOut> {
	( value:FactoryIn ): FactoryOut;
}


/**
 * A class that handles key value mappings with sub mappings
 */
export class Registry<Key, FactoryIn, FactoryOut> {

	protected entries:Map<Key,RegistryFactoryClosure<FactoryIn,FactoryOut>>;

	constructor() {
		this.entries = new Map();
	}

	add( key:any, closure:RegistryFactoryClosure<FactoryIn,FactoryOut> ) {
		this.entries.set( key, closure );
		return this;
	}

	get( key:any ) {
		// check for entry
		let found = this.entries.get( key );

		// return entry if it has and search on constructor if available
		return found ? found : ( key && key.constructor ) ? this.entries.get( key.constructor ) : undefined;

	}
}

